@let cart = cartService.cart();

@if (cart) {
  <div class="wrapper" [class.show]="show" [class.hiding]="hiding">
    <svg class="arrow" width="32" height="32" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M 50,25 100,100 0,100 z" style="fill:white"/>
    </svg>
    <div class="content">
      <div class="heading">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="16" cy="16" r="16" fill="#00923F"/>
          <path d="M24 10L13 21L8 16" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Zum Warenkorb hinzugefügt</span>
        <button type="button" aria-label="Fenster schließen" (click)="hide()" class="btn-close"></button>
      </div>
      <hr>
        <div class="items-wrapper">
          @for (item of cart.items.slice().reverse(); track item) {
            <div class="item d-flex">
              <button (click)="cartService.removeItem(item)" type="button" aria-label="Produkt aus Warenkorb entfernen" class="btn-close"></button>
              <div class="image flex-fill">
                @if (item.distinctProduct.product.getListImageSlug(item.distinctProduct.selectedVariant)) {
                  <img
                    [ngSrc]="item.distinctProduct.product.getListImageSlug(item.distinctProduct.selectedVariant) + ''"
                    alt="{{ item.distinctProduct.product.getListPicture()?.alt }}"
                    ngSrcset="200w, 300w, 400w, 750w"
                    fill
                    class="img-fluid"
                    />
                }
              </div>
              <div class="info flex-fill px-3 py-3 d-flex flex-column">
                <a (click)="hide()" class="title" [routerLink]="[ '/' + item.distinctProduct.product.slug + '.html' ]">{{ item.distinctProduct.product.title }}</a>
                @let attrList = item.getSelectedAttributeList();
                @let dimList = item.getSelectedDimensionsList();
                <div class="attributes">
                  @for (attr of attrList; track attr.code + '|' + attr.label; let i = $index) {
                    {{ attr.label }}: {{ attr.value }}{{ attr.unit ? ' ' + attr.unit : '' }}{{ ( i+1 < attrList.length ) ? ', ' : ''}}
                  }
                  @for (attr of dimList; track attr.code + '|' + attr.label; let i = $index) {
                    {{ attr.label }}: {{ attr.value }}{{ attr.unit ? ' ' + attr.unit : '' }}{{ ( i+1 < dimList.length ) ? ', ' : ''}}
                  }
                </div>
                <div class="qty-price mt-auto d-flex align-items-end">
                  <span>{{ item.getQty() }} St.</span>
                  <span class="ms-auto">{{ item.getPrice() | price }}</span>
                </div>
              </div>
            </div>
          }
        </div>
        <hr>
          <div class="summary d-flex align-items-end"><span>Summe</span><span class="ms-auto">{{ cartService.amounts().total | price }}</span></div>
          <div class="vat-delivery">Inkl. MwSt. exkl. Versandkosten</div>
          <div class="w-100 text-center">
            <a (click)="show = false" class="btn btn-green my-5 align-middle" routerLinkActive="active" [routerLink]="[ '/checkout' ]" title="Kassa">Zur Kassa</a>
          </div>
        </div>
      </div>
    }